import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CheckboxComponent } from '../../../interactive-labels/checkbox/checkbox.component';

@Component({
  selector: 'lib-select-all-checkbox-form-field',
  imports: [CheckboxComponent],
  templateUrl: './select-all-checkbox-form-field.component.html',
  styleUrl: './select-all-checkbox-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectAllCheckboxFormFieldComponent {
  readonly childCheckboxFormControls = input.required<FormControl<boolean>[]>();
  protected disabled = input<boolean>(false);

  protected masterSelected = signal<boolean>(false);
  protected masterIndeterminate = signal<boolean>(false);
  private readonly subscriptions: Subscription[] = [];
  private counter = 0;

  private readonly subscribeEffect = effect(() => {
    const newChildFormControls = this.childCheckboxFormControls();
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    newChildFormControls.forEach((newControl: FormControl<boolean>) => {
      this.subscriptions.push(
        newControl.valueChanges.subscribe((value: boolean) => {
          if (value) this.counter++;
          else this.counter--;

          this.masterSelected.set(this.counter !== 0);
          this.masterIndeterminate.set(this.counter < this.childCheckboxFormControls().length);
        }),
      );
    });
  });

  masterClicked() {
    if (this.masterIndeterminate() || !this.masterSelected()) {
      this.masterSelected.set(true);
      this.masterIndeterminate.set(false);
      this.childCheckboxFormControls().forEach(fc => {
        fc.setValue(true);
      });
      this.counter = this.childCheckboxFormControls().length;
    } else {
      this.masterSelected.set(false);
      this.childCheckboxFormControls().forEach(fc => {
        fc.setValue(false);
      });
      this.counter = 0;
    }
  }
}
